module.exports = __webpack_public_path__ + "components/flag/static/square/tc-f18c5c4ef9b5e221ee4d998d4db703a7.svg";